/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AiMiniTool,
  CreateAiMiniToolInput,
  ListAiMiniToolsParams,
  ListFeaturedAiMiniToolsParams,
  PaginatedAiMiniTools,
  SchemaValidationErrorResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create AI MiniTool
 */
export const createMiniTool = (
    createAiMiniToolInput: MaybeRefOrGetter<CreateAiMiniToolInput>,
 signal?: AbortSignal
) => {
      createAiMiniToolInput = toValue(createAiMiniToolInput);

      return axiosClient<AiMiniTool>(
      {url: `/ai/mini_tools`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAiMiniToolInput, signal
    },
      );
    }




export const getCreateMiniToolMutationKey = () => ['createMiniTool'] as const;

export const getCreateMiniToolMutationOptions = <TError = ErrorType<void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMiniTool>>, TError,CreateMiniToolMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMiniTool>>, TError,CreateMiniToolMutationVariables, TContext> => {

const mutationKey = getCreateMiniToolMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMiniTool>>, CreateMiniToolMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createMiniTool(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMiniToolMutationResult = NonNullable<Awaited<ReturnType<typeof createMiniTool>>>
    export type CreateMiniToolMutationBody = CreateAiMiniToolInput
    export type CreateMiniToolMutationError = ErrorType<void | ValidationError>
    export type CreateMiniToolMutationVariables = {data: CreateAiMiniToolInput}

    /**
 * @summary Create AI MiniTool
 */
export const useCreateMiniTool = <TError = ErrorType<void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMiniTool>>, TError,CreateMiniToolMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createMiniTool>>,
        TError,
        CreateMiniToolMutationVariables,
        TContext
      > => {
      return useMutation(getCreateMiniToolMutationOptions(options), queryClient);
    }
    /**
 * @summary List of AI MiniTools
 */
export const listAiMiniTools = (
    params?: MaybeRefOrGetter<ListAiMiniToolsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiMiniTools>(
      {url: `/ai/mini_tools`, method: 'GET',
        params, signal
    },
      );
    }




export const getListAiMiniToolsQueryKey = (params?: MaybeRefOrGetter<ListAiMiniToolsParams>,) => {
    return [
    'ai','mini_tools', ...(params ? [params] : [])
    ] as const;
    }


export const getListAiMiniToolsQueryOptions = <TData = Awaited<ReturnType<typeof listAiMiniTools>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListAiMiniToolsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiMiniTools>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiMiniToolsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiMiniTools>>> = ({ signal }) => listAiMiniTools(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiMiniTools>>, TError, TData>
}

export type ListAiMiniToolsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiMiniTools>>>
export type ListAiMiniToolsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List of AI MiniTools
 */

export function useListAiMiniTools<TData = Awaited<ReturnType<typeof listAiMiniTools>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListAiMiniToolsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiMiniTools>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiMiniToolsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary List of featured AI MiniTools
 */
export const listFeaturedAiMiniTools = (
    params?: MaybeRefOrGetter<ListFeaturedAiMiniToolsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiMiniTools>(
      {url: `/ai/mini_tools/featured`, method: 'GET',
        params, signal
    },
      );
    }




export const getListFeaturedAiMiniToolsQueryKey = (params?: MaybeRefOrGetter<ListFeaturedAiMiniToolsParams>,) => {
    return [
    'ai','mini_tools','featured', ...(params ? [params] : [])
    ] as const;
    }


export const getListFeaturedAiMiniToolsQueryOptions = <TData = Awaited<ReturnType<typeof listFeaturedAiMiniTools>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListFeaturedAiMiniToolsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeaturedAiMiniTools>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListFeaturedAiMiniToolsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFeaturedAiMiniTools>>> = ({ signal }) => listFeaturedAiMiniTools(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFeaturedAiMiniTools>>, TError, TData>
}

export type ListFeaturedAiMiniToolsQueryResult = NonNullable<Awaited<ReturnType<typeof listFeaturedAiMiniTools>>>
export type ListFeaturedAiMiniToolsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List of featured AI MiniTools
 */

export function useListFeaturedAiMiniTools<TData = Awaited<ReturnType<typeof listFeaturedAiMiniTools>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListFeaturedAiMiniToolsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeaturedAiMiniTools>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListFeaturedAiMiniToolsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete AI MiniTool
 */
export const deleteAiMiniTool = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/mini_tools/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteAiMiniToolMutationKey = () => ['deleteAiMiniTool'] as const;

export const getDeleteAiMiniToolMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiMiniTool>>, TError,DeleteAiMiniToolMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiMiniTool>>, TError,DeleteAiMiniToolMutationVariables, TContext> => {

const mutationKey = getDeleteAiMiniToolMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiMiniTool>>, DeleteAiMiniToolMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAiMiniTool(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiMiniToolMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiMiniTool>>>

    export type DeleteAiMiniToolMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteAiMiniToolMutationVariables = {id: string}

    /**
 * @summary Delete AI MiniTool
 */
export const useDeleteAiMiniTool = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiMiniTool>>, TError,DeleteAiMiniToolMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiMiniTool>>,
        TError,
        DeleteAiMiniToolMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAiMiniToolMutationOptions(options), queryClient);
    }
    /**
 * @summary AI MiniTool
 */
export const getAiMiniTool = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AiMiniTool>(
      {url: `/ai/mini_tools/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetAiMiniToolQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'ai','mini_tools',id
    ] as const;
    }


export const getGetAiMiniToolQueryOptions = <TData = Awaited<ReturnType<typeof getAiMiniTool>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiMiniTool>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiMiniToolQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiMiniTool>>> = ({ signal }) => getAiMiniTool(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiMiniTool>>, TError, TData>
}

export type GetAiMiniToolQueryResult = NonNullable<Awaited<ReturnType<typeof getAiMiniTool>>>
export type GetAiMiniToolQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary AI MiniTool
 */

export function useGetAiMiniTool<TData = Awaited<ReturnType<typeof getAiMiniTool>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiMiniTool>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiMiniToolQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






